export default __webpack_public_path__ + "static/media/sicherer_arbeitsplatz.54efa492.svg";